import {
  pure,
  renderComponent,
  branch,
  compose
} from 'recompose'
import TextArea from './TextArea'
import FieldWrapper from './FieldWrapper'

export default compose(
  branch(props => props.formComponent, renderComponent(FieldWrapper)),
  pure
)(TextArea)



// WEBPACK FOOTER //
// ./components/uiLib/TextArea/index.js